$(function() {
    const tabs = {
        init() {
            tabs.create();
        },
        create() {
            const tabElement = $('[data-tab-element]'),
                tabContent = $('[data-tab-content]');
                
            if (tabContent.length == 0) return;

            $('body').on('click', '[data-tab-element]', function(event) {
                event.preventDefault();
                let name = $(this).data('name');
                if($(this).is('[data-wrap]')) {
                    $(this).addClass('on').parent().siblings().find('[data-tab-element]').removeClass('on');
                } else {
                    $(this).addClass('on').siblings().removeClass('on');
                }

                if($('[data-tab-content][data-name="' + name + '"]').hasClass('w-dropdown')) {
                    $('[data-tab-content][data-name="' + name + '"]').addClass('on').parents('[data-dropdown]').siblings().find('[data-tab-content]').removeClass('on');
                } else {
                    $('[data-tab-content][data-name="' + name + '"]').addClass('on').siblings().removeClass('on');
                }
            });

        },
    };

    tabs.init();
});